import { SVGProps } from 'react';

const ClipboardIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0003 6.66667H9.33366C8.62641 6.66667 7.94814 6.94762 7.44804 7.44772C6.94794 7.94781 6.66699 8.62609 6.66699 9.33333V25.3333C6.66699 26.0406 6.94794 26.7189 7.44804 27.219C7.94814 27.719 8.62641 28 9.33366 28H22.667C23.3742 28 24.0525 27.719 24.5526 27.219C25.0527 26.7189 25.3337 26.0406 25.3337 25.3333V9.33333C25.3337 8.62609 25.0527 7.94781 24.5526 7.44772C24.0525 6.94762 23.3742 6.66667 22.667 6.66667H20.0003M12.0003 6.66667C12.0003 7.37391 12.2813 8.05219 12.7814 8.55229C13.2815 9.05238 13.9597 9.33333 14.667 9.33333H17.3337C18.0409 9.33333 18.7192 9.05238 19.2193 8.55229C19.7194 8.05219 20.0003 7.37391 20.0003 6.66667M12.0003 6.66667C12.0003 5.95942 12.2813 5.28115 12.7814 4.78105C13.2815 4.28095 13.9597 4 14.667 4H17.3337C18.0409 4 18.7192 4.28095 19.2193 4.78105C19.7194 5.28115 20.0003 5.95942 20.0003 6.66667M12.0003 18.6667L14.667 21.3333L20.0003 16"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default ClipboardIcon;
